import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Docs from '/src/_includes/braintree-note.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Docs mdxType="Docs" />
    <h1 {...{
      "id": "payment-method-configuration"
    }}>{`Payment method configuration`}</h1>
    <p>{`In the `}<inlineCode parentName="p">{`config.xml`}</inlineCode>{` file in your `}<inlineCode parentName="p">{`%Vendor_Module%/etc`}</inlineCode>{` directory, configure the options of your payment method. The following table contains the default options available for any payment method.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Option`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Value type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`active`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`is payment active by default`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`debug`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`enables debug mode by default, for example log for request/response`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`debugReplaceKeys`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`request/response fields that are masked in log`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`comma separated list`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`can_authorize`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`whether payment method supports authorization`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`can_capture`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`whether payment method supports the capture operation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`can_void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`whether payment method supports the void operation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`can_use_checkout`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`whether payment method is available in storefront  checkout`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`can_use_internal`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`whether payment method is available in Admin  order creation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`currency`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`supported currency`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`is_gateway`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`is an integration with gateway`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`merchant_gateway_key`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`encrypted merchant credential`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`model`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "facade-configuration.md"
            }}>{`payment method facade`}</a>{` used for integration with Sales and Checkout modules`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`order_status`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`default order status`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`paymentInfoKeys`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`transaction request/response fields displayed on payment information block (can be any fields from payment additional information)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`list of comma separated values`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`privateInfoKeys`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`privateInfoKeys`}</inlineCode>{` fields which should not be displayed in customer payment information block (can be any fields from payment additional information)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`payment_action`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`default action of payment for the payment method (authorize, sale)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`authorize`}</inlineCode>{`,`}<inlineCode parentName="td">{`authorize_capture`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`sort_order`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`payment method order position on checkout/system configuration pages`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`integer`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`title`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`default title for a payment method`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Additionally to the default option, a payment method configuration can contain any other custom options.`}</p>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <p>{`Following is the illustration of such configuration (`}<inlineCode parentName="p">{`config.xml`}</inlineCode>{` of the Braintree module)`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`<config xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:noNamespaceSchemaLocation="urn:magento:module:Magento_Store:etc/config.xsd">
    <default>
        <payment>
            <braintree>
                <model>BraintreeFacade</model>
                <title>Credit Card (Braintree)</title>
                <payment_action>authorize</payment_action>
                <active>0</active>
                <is_gateway>1</is_gateway>
                <can_use_checkout>1</can_use_checkout>
                <can_authorize>1</can_authorize>
                <can_capture>1</can_capture>
                <can_capture_partial>1</can_capture_partial>
                <can_authorize_vault>1</can_authorize_vault>
                <can_capture_vault>1</can_capture_vault>
                <can_use_internal>1</can_use_internal>
                <can_refund_partial_per_invoice>1</can_refund_partial_per_invoice>
                <can_refund>1</can_refund>
                <can_void>1</can_void>
                <can_cancel>1</can_cancel>
                <can_edit>1</can_edit>
                <can_review_payment>1</can_review_payment>
                <can_deny_payment>1</can_deny_payment>
                <cctypes>AE,VI,MC,DI,JCB,CUP,DN,MI</cctypes>
                <useccv>1</useccv>
                <cctypes_braintree_mapper><![CDATA[{"american-express":"AE","discover":"DI","jcb":"JCB","mastercard":"MC","master-card":"MC","visa":"VI","maestro":"MI","diners-club":"DN","unionpay":"CUP"}]]></cctypes_braintree_mapper>
                <order_status>processing</order_status>
                <environment>sandbox</environment>
                <allowspecific>0</allowspecific>
                <sdk_url><![CDATA[https://js.braintreegateway.com/js/braintree-2.32.0.min.js]]></sdk_url>
                <public_key backend_model="Magento\\Config\\Model\\Config\\Backend\\Encrypted" />
                <private_key backend_model="Magento\\Config\\Model\\Config\\Backend\\Encrypted" />
                <masked_fields>cvv,number</masked_fields>
                <privateInfoKeys>avsPostalCodeResponseCode,avsStreetAddressResponseCode,cvvResponseCode,processorAuthorizationCode,processorResponseCode,processorResponseText,liabilityShifted,liabilityShiftPossible,riskDataId,riskDataDecision</privateInfoKeys>
                <paymentInfoKeys>cc_type,cc_number,avsPostalCodeResponseCode,avsStreetAddressResponseCode,cvvResponseCode,processorAuthorizationCode,processorResponseCode,processorResponseText,liabilityShifted,liabilityShiftPossible,riskDataId,riskDataDecision</paymentInfoKeys>
                <avs_ems_adapter>Magento\\Braintree\\Model\\AvsEmsCodeMapper</avs_ems_adapter>
                <cvv_ems_adapter>Magento\\Braintree\\Model\\CvvEmsCodeMapper</cvv_ems_adapter>
                <group>braintree_group</group>
            </braintree>
        </payment>
    </default>
</config>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      